import { restClient } from '@/Core'

/**
 * Зміна власної картки: `PATCH /services/users/{uuid}`.
 *
 * Тіло — лише поля профілю (чи `photo`, чи `plainPassword`): бек перевіряє
 * права на кожне поле тіла ще до десеріалізації, і поле, яке людині не
 * належить (телефон-логін, ролі), дало б 403 на все збереження.
 */
export const UpdateCurrentUserTask = async (
    uuid: string,
    json: Record<string, unknown>
): Promise<Record<string, unknown>> => {
    const response = await restClient.patch(`/services/users/${encodeURIComponent(uuid)}`, { json })

    return (response ?? {}) as unknown as Record<string, unknown>
}
